__webpack_require__.p = "https://pg-prod.mynd-cdn.com/4.2.1/public/bundles/";